import { render, staticRenderFns } from "./authConfig.vue?vue&type=template&id=7f6597d0&scoped=true"
import script from "./authConfig.vue?vue&type=script&lang=js"
export * from "./authConfig.vue?vue&type=script&lang=js"
import style0 from "./authConfig.vue?vue&type=style&index=0&id=7f6597d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6597d0",
  null
  
)

export default component.exports